import script from "./AdminBookingServices.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBookingServices.vue?vue&type=script&setup=true&lang=js"

import "./AdminBookingServices.vue?vue&type=style&index=0&id=8953243a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8953243a"]])

export default __exports__